import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { ContentWrapper } from "../loading/LoadingSkeleton";
import { API_URL } from "../../config";

export default function ArticleInfo() {
	const { id } = useParams();
	const [article, setArticle] = useState(false);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(true);
	const [imageLoaded, setImageLoaded] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const cacheKey = `kriterion-article-info-${id}`;
				const cacheTimeKey = `kriterion-article-info-${id}-time`;
				const cachedData = localStorage.getItem(cacheKey);
				const cacheTime = localStorage.getItem(cacheTimeKey);
				
				if (cachedData && cacheTime && (Date.now() - parseInt(cacheTime)) < 300000) {
					const parsed = JSON.parse(cachedData);
					setArticle(parsed);
					setLoading(false);
					return;
				}

				const response = await axios.get(`${API_URL}/api/links-informatie/${id}`);
				
				const articleData = response.data;
				localStorage.setItem(cacheKey, JSON.stringify(articleData));
				localStorage.setItem(cacheTimeKey, Date.now().toString());
				
				setError("");
				setArticle(articleData);
				setLoading(false);
			} catch (e) {
				if (e.response?.status === 404) {
					setArticle(false);
					setError("Title not found");
				} else {
					setError("Something went wrong, try again later");
				}
				setLoading(false);
			}
		};

		fetchData();
		window.scrollTo(0, 0);
	}, [id]);

	// article && console.log(JSON.parse(article.attributes.Inhoud[1].Afbeelding));

	return (
		<ContentWrapper isLoading={loading && !error} loadingMessage="Artikel wordt geladen...">
			<Helmet>
				<title>{article?.data?.attributes?.Titel ? `${article.data.attributes.Titel} - Informatie - Filmtheater Kriterion` : 'Informatie - Filmtheater Kriterion'}</title>
				<meta name="description" content={article?.data?.attributes?.Titel ? `${article.data.attributes.Titel} - Praktische informatie voor bezoekers van Filmtheater Kriterion Amsterdam.` : 'Praktische informatie voor bezoekers van Filmtheater Kriterion Amsterdam.'} />
			</Helmet>
			<div className="body-container">
			{article?.data?.attributes && (
				<div 
					className="article-content"
					style={{
						opacity: imageLoaded || !article.data.attributes.Inhoud.some(comp => comp.__component === "artikel.afbeelding") ? 1 : 0,
						transition: 'opacity 0.2s ease-in-out'
					}}
				>
					<h1 className="titel">{article.data.attributes.MenuTitel}</h1>
					{// eslint-disable-next-line
                    article.data.attributes.Inhoud.map((comp) => {
						if (comp.__component === "artikel.tekst") {
							return JSON.parse(comp.Tekst).blocks.map((block) => {
								return (
									<p
										className="tekst"
										key={block.id}
										dangerouslySetInnerHTML={{
											__html: block.data.text,
										}}
									/>
								);
							});
						} else if (comp.__component === "artikel.afbeelding") {
                            return (
                                <img 
                                    className="artikel-image" 
                                    key={comp.id} 
                                    src={comp.Afbeelding.data.attributes.url} 
                                    alt="Artikel afbeelding"
                                    loading="lazy"
                                    onLoad={() => setImageLoaded(true)}
                                />
                            )
                        }
					})}
				</div>
			)}
			{error && <p className='error'>{error}</p>}
			</div>
		</ContentWrapper>
	);
}
